import Header from "./components/Header";
import Hero from "./components/Hero";
import ServicesSection from "./components/ServicesSection";
import RelatedServicesSection from "./components/RelatedServicesSection";
import PainPointsSection from "./components/PainPointsSection";
import AboutSection from "./components/AboutSection";
import MessageSection from "./components/MessageSection";
import ContactSection from "./components/ContactSection";
import PartnersSection from "./components/PartnersSection";
import Footer from "./components/Footer";
import Seo from "@/components/feature/Seo";
import { seoMeta, organizationCoreJsonLd, websiteJsonLd } from "@/lib/seo";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Seo
        title={seoMeta.home.title}
        description={seoMeta.home.description}
        structuredData={[organizationCoreJsonLd(), websiteJsonLd()]}
      />
      <Header />
      <main>
        <Hero />
        <PartnersSection />
        <ServicesSection />
        <RelatedServicesSection />
        <PainPointsSection />
        <AboutSection />
        <MessageSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}